import axios from 'axios';
import { DHLError, handleHttpResponse } from '@general/js/utils';
import { getCurrentDate } from '@general/js/utils/dateTimeUtils';
import AbstractClass from './WaitingPeriodAbstractServices';
import { Services } from '../Services';

export default class WaitingPeriodServices extends AbstractClass {
  /**
   * Get reference data of member portal contact us page
   * @returns {object}
   */
  static async getWaitingPeriodsReferenceData() {
    try {
      const response = await axios.get(Services.MY_COVER.WAITING_PERIODS.GET_REFERENCE_DATA);

      if (handleHttpResponse(response)) {
        // return member number string token swapped data
        return JSON.parse(JSON.stringify(response.data).tokenSwap());
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getWaitingPeriodsReferenceData() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Get related articles reference data for member portal contact us confirmation page
   * @returns {object}
   */
  static async getWaitingPeriods(memberNumber, currentDate = getCurrentDate()) {
    try {
      const response = await axios.get(Services.MY_COVER.WAITING_PERIODS.GET_WAITING_PERIODS(memberNumber, currentDate));

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getWaitingPeriods() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
